import { defaultGenerateSearchUrl } from './default-generate-search-url';
import { type QueryParams } from './query-params/types';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getBaseUrl } from './get-base-url';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { defaultGenerateSearchUrl } from './default-generate-search-url';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { defaultOnNavigate } from './default-on-navigate';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { isOnJiraFullPageSearch } from './is-on-jira-full-page-search';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { isDummyBoardUrl } from './is-dummy-board-url';

/**
 * Checks if the user is currently on the search page route by comparing
 * the current pathname with the pathname generated by `generateSearchUrl`.
 *
 * Returns `undefined` if URL parsing fails.
 *
 * @param generateSearchUrl - A function that generates the search URL for the given query parameters.
 *                            Defaults to `defaultGenerateSearchUrl`.
 * @returns `true` if the current pathname matches the search page pathname.
 */
export function isOnSearchRoute(
	generateSearchUrl: (queryParams: QueryParams) => string = defaultGenerateSearchUrl,
): boolean | undefined {
	try {
		const searchPath = new URL(generateSearchUrl({})).pathname;
		const currentPath = new URL(window.location.href).pathname;

		return searchPath === currentPath;
	} catch {
		return undefined;
	}
}

/**
 * Checks if the given destination URL points at the search page route by
 * comparing its pathname with the pathname generated by `generateSearchUrl`.
 *
 * Relative URLs are resolved against the current location.
 *
 * Returns `undefined` if URL parsing fails.
 *
 * @param destinationUrl - The URL being navigated to.
 * @param generateSearchUrl - A function that generates the search URL for the given query parameters.
 *                            Defaults to `defaultGenerateSearchUrl`.
 * @returns `true` if the destination pathname matches the search page pathname.
 */
export function isSearchRouteUrl(
	destinationUrl: string,
	generateSearchUrl: (queryParams: QueryParams) => string = defaultGenerateSearchUrl,
): boolean | undefined {
	try {
		const searchPath = new URL(generateSearchUrl({})).pathname;
		const destinationPath = new URL(destinationUrl, window.location.href).pathname;

		return searchPath === destinationPath;
	} catch {
		return undefined;
	}
}
